import React, {Fragment, useRef, useState} from 'react'
import Autosuggest from 'react-autosuggest';
import IsolatedScroll from "react-isolated-scroll";
import LoadingSpinner from "../../components/LoadingSpinner";
import {useAPI} from "../../config/API";

const ProjectTemplateTagSearch = (props) => {

    const [search, setSearch] = useState('');
    const [querySearch, setQuerySearch] = useState('');

    const [suggestions, setSuggestions] = useState([]);

    const inputRef = useRef(null);
    const selectedTags = props.selectedTags;

    const {
        data,
        isFetching,
        isInitialLoading: isLoading,
        error,
        refetch
    } = useAPI(['searchProjectTemplateTags', querySearch], {
            enabled: querySearch?.length > 0,

            select: (response) => {
                if (!selectedTags?.length) return response;

                let selectedTagIds = TB.pluck(selectedTags, 'id');

                let filteredSuggestions = TB.filter(response, tag => !selectedTagIds.includes(tag?.id))

                if (!filteredSuggestions.length) {
                    filteredSuggestions.push({empty: true})
                }
                return filteredSuggestions
            },
            onSuccess: (suggest) => {
                console.log('onSuccess', suggest)
                setSuggestions(suggest || [])
            }
        }
    );

    const onChange = (event, {newValue}) => {
        setSearch(newValue)
    };

    const onSuggestionsClearRequested = () => {
        return setSuggestions([])
    };

    const onSuggestionSelected = async (event, {suggestion}) => {
        event?.preventDefault();
        await onSuggestionsClearRequested();

        let tags = TB.xorBy(selectedTags, [suggestion], 'id');

        await props.onChange(tags);

        setQuerySearch('')
        return setSearch('')
    }

    const onSuggestionsFetchRequested = async ({value}) => {
        setQuerySearch(value)
    };


    const inputProps = {
        // placeholder: 'Type search terms here (Optional)',
        placeholder: 'Search key words',
        value: search,
        name: 'keyword-search',
        onChange,
        disabled: props.isDisabled
    };


    const renderInputComponent = (inputProps) => {

        let hasValue = !isLoading && search !== '';

        let empty = false, emptyProps = {};
        if (!isLoading && suggestions?.length === 1) {
            empty = TB.find(suggestions, ['empty', true]);
            if (empty) {
                emptyProps = {
                    onKeyDown: e => e.keyCode === 40 && e.preventDefault(),
                    onClick: e => e.preventDefault()
                }
            }
        }
        return (
            <Fragment>
                <div className="input-group">
                    <input
                        {...inputProps}
                        {...emptyProps}
                        autoComplete={'off'}
                        autoCapitalize={'words'}
                    />
                    {
                        (hasValue || empty) ? (
                            <span onClick={async (event) => {
                                await setSearch('');
                                await setQuerySearch('');
                                await setSuggestions([]);

                                inputRef.current?.input?.focus()
                            }} className="clickable input-group-prepend">
                                <i className="fa fa-times"/>
                            </span>
                        ) : (isLoading && !props.isDisabled && (
                            <span className="input-group-prepend">
                                <LoadingSpinner type={'success'}/>
                            </span>
                        ))
                    }
                </div>
                {
                    (empty || error) && (
                        <ul key={"suggest-empty"}
                            className="no-click border-gray-100 w-full react-autosuggest__suggestions-list">
                            <li className="react-autosuggest__suggestion react-autosuggest__suggestion--first">
                                <p className="suggestion-empty suggestion">
                                    {error ?
                                        'Something went wrong. Please try again later.' :
                                        '0 results found. Try editing your search.'
                                    }
                                </p>
                            </li>
                        </ul>
                    )
                }
            </Fragment>
        )
    }

    const getSuggestionValue = (suggestion) => {
        return suggestion?.name;
    }

    const renderSuggestion = (suggestion, {query, isHighlighted}) => {

        if (!suggestion || suggestion.empty) return null;

        return (
            <p className={"suggestion tag-suggestion " + (isHighlighted && "highlighted-suggestion")}>
                {suggestion.isCustom ? (
                    <span>
                        {suggestion.isUnique ? (
                            <span>
                                Add keyword <span className={"custom-name"}>{suggestion.name}</span>
                            </span>
                        ) : (
                            <span className={"text-italic"}>
                                Add keyword <span className={"custom-name"}>{suggestion.name}</span>
                            </span>
                        )}
                    </span>
                ) : suggestion.name}

                {isHighlighted && (!suggestion.isCustom || !suggestion.isUnique) && (
                    <span className="suggestion-help">
                        Press enter to add
                    </span>
                )}
            </p>
        );
    }

    const shouldRenderSuggestions = (value) => {
        return value.trim().length >= 1;
    }

    const renderSuggestionsContainer = ({containerProps, children}) => {
        const isDisabled = isFetching || props.isDisabled;
        const {ref, ...restContainerProps} = containerProps;
        const callRef = isolatedScroll => {
            if (isolatedScroll !== null) {
                ref(isolatedScroll.component);
            }
        };

        if (!restContainerProps.className) {
            restContainerProps.className = "suggest";
        }
        if (isDisabled) restContainerProps.className += " suggestions-disabled";

        return (
            <IsolatedScroll ref={callRef} {...restContainerProps}>
                {children}
            </IsolatedScroll>
        );
    }

    return (
        <div className="tag-search-container">

            <div className="mb-3">
                <p className="text-lg font-medium mb-2">My Project Tags</p>
                {selectedTags?.length > 0 && (
                    <div className="flex flex-row flex-wrap gap-1.5">
                        {selectedTags.map(tag => (
                            <button
                                type="button"
                                onClick={e => onSuggestionSelected(e, {suggestion: tag})}
                                disabled={props.isDisabled}
                                key={`tag-${tag.name}`}
                                className="flex justify-start items-center relative gap-2.5 px-2 py-1 rounded-xl bg-[#8b63e7]">

                                <p className="text-xs font-medium text-white">{tag.name}</p>
                                <i className="fas fa-times text-xs text-white"/>
                            </button>
                        ))}
                    </div>
                )}
            </div>
            <Autosuggest
                ref={inputRef}
                inputProps={inputProps}
                suggestions={suggestions}
                highlightFirstSuggestion={true}
                renderSuggestion={renderSuggestion}
                getSuggestionValue={getSuggestionValue}
                shouldRenderSuggestions={shouldRenderSuggestions}
                renderInputComponent={renderInputComponent}
                onSuggestionSelected={onSuggestionSelected}
                renderSuggestionsContainer={renderSuggestionsContainer}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
            />



        </div>
    )
}

export default ProjectTemplateTagSearch;